export default function (...args)
{
	return {
		regex: /^([\w\-]+(?:\.[\w\-]+)*@[\w\-]+(?:\.[\w\-]+)+)$/i,
		setValue(value, _this = this)
		{
			this.safeProtoCall(value?.toLowerCase(), _this);
		}
	};
}

